module.exports = __webpack_public_path__ + "518b26d9266f4f7709b336e5912a843c.png";